export let ServiceType;

(function (ServiceType) {
  ServiceType["Economy"] = "economy";
  ServiceType["Standard"] = "standard";
})(ServiceType || (ServiceType = {}));